import { useState, useEffect } from "react";
import { getBoothWithSaltoData } from "../services/api";

export function useBoothData(boothId) {
	const [booth, setBooth] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!boothId) {
			setError("No booth ID provided");
			setLoading(false);
			return;
		}

		const fetchBoothData = async () => {
			try {
				setLoading(true);
				setError(null);

				const data = await getBoothWithSaltoData(boothId);

				// Structure the booth data for easy consumption
				const structuredBooth = {
					...data.booth,
					// Ensure location is populated object, not just ID
					location:
						typeof data.booth.location === "object"
							? data.booth.location
							: null,
					// Include Salto integration data
					saltoInfo: data.saltoInfo,
				};

				setBooth(structuredBooth);
			} catch (err) {
				console.error("❌ Error fetching booth data:", err);
				setError(err.message || "Failed to load booth information");
			} finally {
				setLoading(false);
			}
		};

		fetchBoothData();
	}, [boothId]);

	// Refetch function for manual refresh
	const refetch = async () => {
		if (!boothId) return;

		try {
			setLoading(true);
			setError(null);
			const data = await getBoothWithSaltoData(boothId);
			const structuredBooth = {
				...data.booth,
				location:
					typeof data.booth.location === "object" ? data.booth.location : null,
				saltoInfo: data.saltoInfo,
			};
			setBooth(structuredBooth);
		} catch (err) {
			setError(err.message || "Failed to refresh booth information");
		} finally {
			setLoading(false);
		}
	};

	return {
		booth,
		loading,
		error,
		refetch,
		// Convenience flags
		isReady: !loading && !error && booth,
		isEmpty: !loading && !error && !booth,
	};
}

export default useBoothData;
